/**
 * Copyright Mántum All Rights Reserved.
 */
export const KEY_FIELD = 'key';
export const NAME_FIELD = 'name';
export const SIZE_FIELD = 'size';
export const TYPE_FIELD = 'type';
export const URL_FIELD = 'url';
